var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-cbt-add-modal-component" }, [
    _c("div", { staticClass: "room-cbt-add-modal flex flex-col" }, [
      _c(
        "div",
        { staticClass: "room-cbt-add-modal-header px-1" },
        [
          _c("h6", [_vm._v("문제집 추가")]),
          _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "mt-6 flex flex-col gap-4 min-h-0 flex-1 overflow-hidden px-1",
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col gap-2" },
            [
              _vm._m(0),
              _c("GrmTextField", {
                staticClass: "w-full",
                attrs: { size: "xs" },
                model: {
                  value: _vm.cbtTitle,
                  callback: function ($$v) {
                    _vm.cbtTitle = $$v
                  },
                  expression: "cbtTitle",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "flex flex-col gap-2" }, [
            _vm._m(1),
            _c("input", {
              staticClass: "w-full text-xs",
              attrs: { type: "file", accept: ".pdf", id: "cbt-file" },
              on: { input: _vm.onUploadCBTFile },
            }),
          ]),
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-2 min-h-0 flex-1 overflow-y-auto",
            },
            [
              _c("div", { staticClass: "h-8 flex items-center gap-2" }, [
                _c("p", { staticClass: "font-bold" }, [
                  _vm._v(
                    "문항 수 및 문항별 정답 (최대 " +
                      _vm._s(_vm.cbtMaxAnswerCount) +
                      "개)"
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-1" },
                  [
                    _c("GrmTextField", {
                      staticClass: "w-16",
                      attrs: {
                        type: "number",
                        min: 1,
                        max: _vm.cbtMaxAnswerCount,
                        size: "xs",
                      },
                      model: {
                        value: _vm.cbtAnswerCount,
                        callback: function ($$v) {
                          _vm.cbtAnswerCount = $$v
                        },
                        expression: "cbtAnswerCount",
                      },
                    }),
                    _c("span", { staticClass: "text-sm" }, [_vm._v("개")]),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "p-2 min-h-0 flex-1 overflow-y-auto relative" },
                _vm._l(_vm.cbtQuestionList, function (cbtQuestion, i) {
                  return _c(
                    "div",
                    {
                      key: cbtQuestion.questionOrder,
                      staticClass: "flex items-center gap-1",
                      class:
                        i !== 0 &&
                        (i + 1) % cbtQuestion.answerList.length === 0 &&
                        i + 1 !== _vm.cbtQuestionList.length
                          ? "border-b pb-3 mb-3"
                          : "",
                    },
                    [
                      _c("span", { staticClass: "w-8 text-sm inline-block" }, [
                        _vm._v(_vm._s(_vm.number(i + 1)) + "."),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-0.5" },
                        _vm._l(cbtQuestion.answerList, function (answer, j) {
                          return _c(
                            "button",
                            {
                              key: answer.answerOrder,
                              staticClass:
                                "w-4 h-4 rounded-full text-xs flex justify-center items-center",
                              class: answer.correct ? "bg-black" : "border",
                              on: {
                                click: function ($event) {
                                  return _vm.onChangeAnswer(
                                    answer.correct,
                                    answer.answerOrder,
                                    cbtQuestion
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(j + 1))]
                          )
                        }),
                        0
                      ),
                      _c(
                        "div",
                        { staticClass: "flex items-center text-sm" },
                        [
                          _vm._v(" ("),
                          _c("GrmTextField", {
                            staticClass: "w-10",
                            attrs: { type: "number", min: 1, size: "2xs" },
                            model: {
                              value: cbtQuestion.questionScore,
                              callback: function ($$v) {
                                _vm.$set(cbtQuestion, "questionScore", $$v)
                              },
                              expression: "cbtQuestion.questionScore",
                            },
                          }),
                          _c("span", { staticClass: "text-sm" }, [
                            _vm._v("점)"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _c("GrmBtn", { on: { click: _vm.onAddCBT } }, [
            _vm._v("문제집 추가하기"),
          ]),
        ],
        1
      ),
    ]),
    _vm.isLoading
      ? _c(
          "div",
          { staticClass: "fixed inset-0 bg-black bg-opacity-10" },
          [_c("GrmLoadingCircle")],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "h-8 flex items-center" }, [
      _c("p", { staticClass: "font-bold" }, [_vm._v("제목")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "h-8 flex items-center" }, [
      _c("p", { staticClass: "font-bold" }, [_vm._v("문제집")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }